import script from "./EventLiveBadge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventLiveBadge.vue?vue&type=script&lang=js"
export * from "./EventLiveBadge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventLiveBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/event-card/EventLiveBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5109d7fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5109d7fc', __exports__)) {
    api.reload('5109d7fc', __exports__)
  }
  
}


export default __exports__